'use client'

import {
  createContext,
  PropsWithChildren,
  useContext,
} from 'react'

import { Env } from '@/lib/env'

const EnvContext = createContext<Env | null>(null)

export interface EnvProviderProps extends PropsWithChildren {
  env: Env
}

export const EnvProvider = ({
  children,
  env,
}: EnvProviderProps) => {
  return <EnvContext.Provider value={env}>{children}</EnvContext.Provider>
}

export const useEnv = () => {
  const env = useContext(EnvContext)
  if (!env) {
    throw new Error('useEnv must be used within an EnvProvider')
  }
  return env
}
